import { ScheduleTreatment } from '../entities/ScheduleTreatment';
import { Calendar } from '../features/calendar/calendar-slice';
import { CalendarServiceType } from '../models/ICalendarServiceType';
import { IUser } from '../models/IUser';
import { compareDates } from '../lib/dayjs';
import { api } from './api.service';

export interface IRequest {
  journeyId: string;
}

export interface ISteps {
  currentStep: string;
  nextSteps: string;
  previousSteps: string;
}

export interface IPaymentAddress {
  address: string;
  addressComplement: string;
  addressNumber: string;
  addressReference: string;
  cep: string;
  city: string;
  neighborhood: string;
  state: string;
}
export interface IPayments {
  address: IPaymentAddress;
  amount: number;
  cupomCode: string;
  discount: number;
  id: string;
  installments: number;
  method: 'creditCard' | 'pix' | 'healthPlan' | '';
  paymentDate: any;
  status: string;
}

export interface IAddress {
  address: string;
  addressComplement: string;
  addressNumber: string;
  addressReference: string;
  cep: string;
  city: string;
  neighborhood: string;
  state: string;
  alias: string;
}

export interface ISchedules {
  address: IAddress;
  dateStart: string;
  dateEnd: string;
  id: string;
  returnSchedule: boolean;
  status: string;
  type: string;
  calendarId: string;
  calendar: {
    id: string;
    alias: string;
    type: string;
  };
  teleUrl: string;
  allowReschedule: boolean;
  isNeedCollectCSAT: boolean;
  user: IUser;
  calendarServiceType: CalendarServiceType;
  rescheduleAlert?: boolean;
  rescheduleReason?: string | null;
  attendanceConfirmed: boolean;
  ratingRate?: number;
}

export interface InfoFiles {
  id: string;
  name: string;
  fileType: string;
  url: string;
  date: string;
}

export interface Files {
  exams: InfoFiles[];
  reports: InfoFiles[];
  requests: InfoFiles[];
  surgicalReports: InfoFiles[];
  surgicalVideos: InfoFiles[];
  // others: InfoFiles[];
}

export enum ECalendarType {
  MAIN = 'MAIN',
  RETURN = 'RETURN',
  BOTH = 'BOTH'
}
export interface CalendarTypes {
  id: string;
  calendarId: string;
  type: ECalendarType.MAIN | ECalendarType.RETURN | ECalendarType.BOTH;
  createdAt: string;
  productId: string;
  updatedAt: string;
}
export interface IJourneyResp {
  doctor?: {
    name: string;
    profileImage: string;
    profileUrl: string;
    id?: string;
  };
  haveToAnswerAnamnese: string;
  journeyid: string;
  schedules: Array<ISchedules>;
  payments: Array<IPayments>;
  product: {
    id: string;
    name: string;
    alias: string;
  };
  steps: ISteps;
  status: string;
  calendars?: Calendar[];
  calendarSecundary: Calendar | null;
  files: Files;
  calendarTypes: Array<CalendarTypes>;
  canScheduleReturn: boolean;
  restrictReturn: boolean;
  scheduleTreatments: ScheduleTreatment[];
  clinic?: {
    id?: string;
    name?: string;
    googleReviewURL?: string;
  };
  nps?: number | null;
}

export const getLastSchedule = (journey: IJourneyResp): ISchedules | undefined =>
  [...(journey.schedules ?? [])]
    .filter(schedule => !!schedule.dateStart)
    .sort((a, b) => compareDates(b.dateStart, a.dateStart))[0];

export const Journey = api.injectEndpoints({
  endpoints: build => ({
    getJourneyById: build.mutation<IJourneyResp, IRequest>({
      query: ({ journeyId }) => ({
        url: `/portal/v1/me/journey/${journeyId}`
      })
    })
  })
});

export const { useGetJourneyByIdMutation } = Journey;
